import React, { Component } from 'react';
import Popup from '../widgets/Popup'; // Import the appropriate library for the popup
import { connect } from 'react-redux';
import {fetchEventLocations} from '../../actions/playlist';
class EventsPlaylistModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event_playlist_name: '',
      selectedLocation:'',
      eventLocations:[],
      event_type:'',
    };
  }

  async componentDidMount() {
    try {
      const locations = await fetchEventLocations();
      this.setState({ eventLocations: locations });
    } catch (err) {
      console.error('Error fetching event locations:', err);
      alert(err);
    }
  }

  handleLocationChange = (e) => {
    this.setState({ selectedLocation: e.target.value });
  };


  handleEventType = (e) => {
    this.setState({ event_type: e.target.value });
  };

  onSaveEventPlaylist = () => {
    const { event_playlist_name, selectedLocation, event_type } = this.state;

    // Implement the logic for saving the event playlist
    if(event_playlist_name.trim().length != 0 && selectedLocation.length != 0 &&
    event_type.trim().length != 0){
      this.props.handleAddEventPlaylist(event_playlist_name, selectedLocation, event_type)
    this.props.onTogggleCreateEventPlaylist()

    }
    
  };
  

  isSaveButtonDisabled() {
    const { event_playlist_name, selectedLocation, event_type } = this.state;

  
      if (event_playlist_name.trim().length === 0 && selectedLocation.length === 0 &&
      event_type.trim().length === 0){
        return true;
      }
      else{
        return false
      }
      

    
  }

  render() {
    const { event_playlist_name, eventLocations, selectedLocation, event_type } = this.state;
    // console.log("loc", selectedLocation);

    return (
      <Popup
        className="text-center"
        title="Create Event Playlist"
        modal
        onCancel={this.props.onTogggleCreateEventPlaylist}
      >
        <div className="modal-events">
          <input
            className="form-control"
            placeholder="Event Playlist"
            id="add-event"
            type="text"
            value={event_playlist_name}
            onChange={(e) =>
              this.setState({ event_playlist_name: e.target.value })
            }
          />

          <select name="channel" title="Select a channel"
          onChange={this.handleEventType}
          value={event_type}
          >
            <option key="NULL" value="">
              Select the type of event
            </option>
            <option key="current" value="current">
              Current Events
            </option>
            <option key="upcoming" value="upcoming">
              Upcoming Events
            </option>
            <option key="upcoming_current" value="upcoming_current">
              Current + Upcoming Events
            </option>
          </select>

          <select
            name="channel"
            title="Select a channel"
            value={this.state.selectedLocation}
            onChange={this.handleLocationChange}
          >
            <option key="NULL" value="">
              Select event location
            </option>
            {eventLocations.map((location) => (
              <option key={location.id} value={location.id}>
                {location.name}
              </option>
            ))}
          </select>

          <div className="text-center pb flex flex-jc-sb ">
            <div></div>
            <div>
              <button
                className="button primary"
                disabled={event_playlist_name.trim().length === 0 && selectedLocation.length === 0 &&
                  event_type.trim().length === 0}
                onClick={this.onSaveEventPlaylist}
              >
                Save
              </button>
              <button
                className="button"
                onClick={this.props.onTogggleCreateEventPlaylist}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Popup>
    );
  }
}


export default EventsPlaylistModal;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/EventsPlaylistModal/index.js